import {
  useFloatingLinkEdit,
  useFloatingLinkEditState,
  useFloatingLinkInsert,
  useFloatingLinkInsertState,
  useFloatingLinkSelectors,
} from 'lib-knowledge-document-structure';
import { TEditableProps } from 'lib-knowledge-document-structure/plate/common';

import { EditLinkTabs } from './editLinkTabs';
import { LinkDetails } from './linkDetails';

export function LinkMenu({ readOnly }: TEditableProps): JSX.Element | null {
  const isEditing = useFloatingLinkSelectors().isEditing();

  const state = useFloatingLinkInsertState();
  const { props: insertProps, ref: insertRef } = useFloatingLinkInsert(state);

  const editState = useFloatingLinkEditState();
  const {
    props: editProps,
    ref: editRef,
    editButtonProps,
    unlinkButtonProps,
  } = useFloatingLinkEdit(editState);

  const mode = useFloatingLinkSelectors().mode();
  const linkType = useFloatingLinkSelectors().linkType();

  if (readOnly || !mode) return null;

  const input = <EditLinkTabs />;

  const editContent = isEditing ? (
    input
  ) : (
    <LinkDetails
      linkType={linkType}
      editButtonProps={editButtonProps}
      unlinkButtonProps={unlinkButtonProps}
    />
  );

  return (
    <>
      <div ref={insertRef} {...insertProps}>
        {input}
      </div>

      <div ref={editRef} {...editProps}>
        {editContent}
      </div>
    </>
  );
}
